/**
 * While any export runs, the canvas is reparented into a fixed overlay that
 * covers the whole viewport at the correct aspect ratio, hiding all UI
 * chrome. This lets a native OS screen recording capture a clean frame with
 * no crop step — kept regardless of whether in-app export works.
 */
export interface FullscreenStage {
  enter(showStopButton: boolean): void;
  exit(): void;
}

export function createFullscreenStage(opts: {
  canvas: HTMLCanvasElement;
  holder: HTMLElement;
  stage: HTMLElement;
  stopButton: HTMLElement;
}): FullscreenStage {
  const { canvas, holder, stage, stopButton } = opts;
  return {
    enter(showStopButton) {
      stage.insertBefore(canvas, stopButton);
      stage.hidden = false;
      stopButton.hidden = !showStopButton;
    },
    exit() {
      holder.appendChild(canvas);
      stage.hidden = true;
      stopButton.hidden = true;
    },
  };
}
